import { FC } from "react";
import { IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { SuspensionEvent } from "refsix-js-models";
import { formatSuspensionDuration } from "refsix-core";
import { DisplayEvent } from "../../models/DisplayEvent";
import "../components.css";

interface RenderSuspensionLogInterface {
    displayEvent: DisplayEvent;
}

// REFSIX-647: a suspension row reads "Match suspended · 21' · Resumed after
// 1:02:11". While the match is still suspended there is no end yet, so the
// duration line is left out rather than shown as a running value.
export const RenderSuspensionLog: FC<RenderSuspensionLogInterface> = ({
    displayEvent,
}) => {
    const { t } = useTranslation();
    const suspension = displayEvent.event as SuspensionEvent;

    return (
        <div className="log-half-container" data-testid="match-log-suspension">
            <div className="log-middle-wrapper">
                <IonText className="log-event-name-text">
                    {t("model.WatchFixture.suspensionDisplayName")}
                </IonText>
                <IonText className="log-minute-play-text">
                    {displayEvent.displayMinute}
                </IonText>
                {suspension.endTime !== undefined && (
                    <IonText
                        className="log-minute-play-text"
                        data-testid="match-log-suspension-duration"
                    >
                        {t("model.WatchFixture.suspensionResumedAfter", {
                            duration: formatSuspensionDuration(
                                suspension.endTime - suspension.timestamp
                            ),
                        })}
                    </IonText>
                )}
            </div>
        </div>
    );
};
